const CRUD_GOALS: FleetOps.Permission =
  'fleetops.permissions.goal_management_crud';

const GOAL_MANAGEMENT_PERMISSIONS = {
  CRUD_GOALS,
};
Object.freeze(GOAL_MANAGEMENT_PERMISSIONS);

export default GOAL_MANAGEMENT_PERMISSIONS;
